import React, { Suspense, useCallback, useEffect, useState } from "react";
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Row,
  Col
} from "reactstrap";
import {
  ACTIVE,
  ALL,
  PROCESSING,
  showToastType,
  STATUS_1,
  STATUS_2
} from "../../../utils/constants/appConstants";
import { commonText, fundedInvoicesData } from "../../../locales/en";
import ErrorBoundary from "../../error-boundary";
import ComponentViewFallback from "../../error-boundary/fallback/ComponentViewFallback";
import Fundedtable from "../../table/all-tables/fundedtable/Fundedtable";
import { getQuoteSummaryUrl } from "../../../utils/constants/apiEndPoints";
import privateAxios from "../../../utils/axiosPrivate";
import { showToast } from "../../../utils/utils";

const FundedTab = () => {
  const [activeTab, setActiveTab] = useState(STATUS_2);
  const [quoteSummary, setQuoteSummary] = useState(null);

  // The summary totals cover every quote on the account regardless of the tab,
  // so they are fetched here rather than in the table: each tab mounts its own
  // Fundedtable, and fetching there would repeat the call on every switch.
  const fetchQuoteSummary = useCallback(async () => {
    try {
      const response = await privateAxios.get(getQuoteSummaryUrl, {
        params: { quoteStatus: ALL }
      });
      setQuoteSummary(response?.data?.data);
    } catch (error) {
      showToast(error?.response?.data?.message, showToastType?.error);
    }
  }, []);

  useEffect(() => {
    fetchQuoteSummary();
  }, [fetchQuoteSummary]);

  return (
    <>
      <Nav tabs className="invoice-nav custom-nav-link">
        <NavItem>
          <NavLink
            className={activeTab === STATUS_1 ? ACTIVE : ""}
            onClick={() => setActiveTab(STATUS_1)}
          >
            {fundedInvoicesData?.funded?.filter?.all}
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={activeTab === STATUS_2 ? ACTIVE : ""}
            onClick={() => setActiveTab(STATUS_2)}
          >
            {fundedInvoicesData?.funded?.filter?.dueInvoice}
          </NavLink>
        </NavItem>
      </Nav>

      <TabContent
        activeTab={activeTab}
        id="invoice-tabcontent"
        className="pt-0"
      >
        <TabPane tabId={STATUS_1}>
          <Row>
            <Col sm="12">
              {activeTab === STATUS_1 && (
                <div className="fundtable-wrap">
                  <ErrorBoundary fallback={<ComponentViewFallback />}>
                    <Fundedtable
                      invoiceType={ALL}
                      key={ALL}
                      quoteSummary={quoteSummary}
                      onQuoteSummaryRefresh={fetchQuoteSummary}
                    />
                  </ErrorBoundary>
                </div>
              )}
            </Col>
          </Row>
        </TabPane>
        <TabPane tabId={STATUS_2}>
          <Row>
            <Col sm="12">
              {activeTab === STATUS_2 && (
                <Suspense
                  fallback={
                    <div className="text-center ">
                      {commonText.fallbackLoader}
                    </div>
                  }
                >
                  <ErrorBoundary fallback={<ComponentViewFallback />}>
                    <Fundedtable
                      invoiceType={PROCESSING}
                      key={PROCESSING}
                      quoteSummary={quoteSummary}
                      onQuoteSummaryRefresh={fetchQuoteSummary}
                    />
                  </ErrorBoundary>
                </Suspense>
              )}
            </Col>
          </Row>
        </TabPane>
      </TabContent>
    </>
  );
};

export default FundedTab;
